import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { AuthService } from "app/auth/auth.service";
import { EMPTY, takeUntil } from "rxjs";
import { environment } from "../../environments/environment";

export const globalCancelInterceptor: HttpInterceptorFn = (req, next) => {
    const authService = inject(AuthService);

    const isAllowedDuringLogout = [
        `${environment.baseUrl}/authentication/logout`,
        `${environment.baseUrl}/authentication/providers`,
    ].some((url) => req.url.startsWith(url));

    if (
        authService.isLogoutInProgress() &&
        req.url.startsWith(environment.baseUrl) &&
        !isAllowedDuringLogout
    ) {
        console.warn(`[logout] Blocked request: ${req.method} ${req.url}`);
        return EMPTY;
    }

    return next(req).pipe(takeUntil(authService.cancelSignal$));
};
